import { render, staticRenderFns } from "./TaxpayerId.vue?vue&type=template&id=07b904d3&scoped=true"
import script from "./TaxpayerId.vue?vue&type=script&lang=js"
export * from "./TaxpayerId.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/W9_form/taxpayer.css?vue&type=style&index=0&id=07b904d3&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b904d3",
  null
  
)

export default component.exports